import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify'; // ou votre lib de toast
import { useTranslation } from 'react-i18next'; // ou votre lib de traduction

const ErrorHandler = (error, clearErrorAction) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    let errorList = []
    if (error && error.data && error.data.errors) {
      error.data.errors.forEach(err => {
        if (err.code) {
          // Construire le message d'erreur
          let errorMessage;
          if (err.key) {
            errorMessage = Array.isArray(err.key) ? 
              err.key.forEarch(kye => {
                errorList.push(t(kye.charAt(0).toLowerCase() + kye.slice(1)) + ': ' + t(err.code));
              }) : 
              t(err.key.charAt(0).toLowerCase() + err.key.slice(1)) + ': ' + t(err.code);
          } else {
            errorMessage = t(err.code);
          }

          if (errorList.length > 0) {
            errorList.forEach(message => {
              toast.error(message);
            });
          } else {
            toast.error(errorMessage);
          }
          
          // Clear l'erreur du store
          if (clearErrorAction) {
            dispatch(clearErrorAction());
          }

          // Reload si BAD_ROWVERSION
          if (err.code === 'BAD_ROWVERSION') {
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        } else {
          toast.error(t('GENERIC_ERROR'));
        }
      });
    } else if(error){
      toast.error(t('GENERIC_ERROR'));
    }
  }, [error, dispatch, clearErrorAction, t]);
};

export default ErrorHandler;